<div style="width: 100%;height: 100%;display: flex;flex-direction: column;align-items: center;overflow: hidden;background: #000000bf;"
    (keydown)="keydown($event)" tabindex="-1">
    <div style="display: flex;justify-content: space-between;align-items: center;padding:0.5rem;">
        <span multilang style="font-size: 1.3rem;font-weight: 600;padding: .5rem;">{{title}}</span>
    </div>
    <div style="display: flex;width: 70%;height: 70%;max-width: 100%;"
        [style.width]="desktopTemplate !== 'xs' ? '70%' : '100%'">
        <div *ngIf="images" class="imagesliderbounds">
            <button *ngIf="totalcount > 0 && currentImagePosition > 0" mat-button class="left-arrow"
                (click)="previus($event);">
                <mat-icon>arrow_back_ios</mat-icon>
            </button>
            <button *ngIf="images?.length > 0 && currentImagePosition < totalcount - 1" mat-button class="right-arrow"
                (click)="next($event);">
                <mat-icon>arrow_forward_ios</mat-icon>
            </button>
            <ng-container *ngTemplateOutlet="!currentNavViedo ? bigimages : bigvideos"></ng-container>
        </div>
    </div>

    <ng-container *ngTemplateOutlet="!currentNavViedo ? imagescount : videoscopunt"></ng-container>
    <div *ngIf="images"
        style="padding: 0 0.5rem;width: 100%;display: flex;justify-content: center; flex-direction: column;">
        <div style="display: flex;padding: .5rem;width: 100%;justify-content: center;">
            <span multilang *ngIf="videos?.length > 0"
                style="font-size: 1.2rem;margin: 0 1.5rem;padding: .3rem;cursor: pointer;"
                [style.border-bottom]="currentNavViedo ? 'solid 2px #fff' : ''" (click)="changeNav($event)">Videos
                ({{videos?.length}})</span>
            <span multilang *ngIf="images?.length > 0"
                style="font-size: 1.2rem;margin: 0 1.5rem;padding: .3rem;cursor: pointer;"
                [style.border-bottom]="!currentNavViedo ? 'solid 2px #fff' : ''" (click)="changeNav($event)">Images
                ({{images?.length}})</span>
        </div>
        <ng-container *ngTemplateOutlet="!currentNavViedo ? miniimages : minivideos"></ng-container>
    </div>
</div>

<button style="position: fixed;top: 4px;right: 4px;cursor: pointer;" (click)="onClose()">
    <mat-icon style="font-size: 44px;cursor: pointer;width: unset;height: unset;">close</mat-icon>
</button>
<ng-container *ngIf="currentCustomer?.token?.length > 0 && showSave">
    <button style="position: fixed;top: 4px;left: 4px;cursor: pointer;" (click)="saveBilder()">
        <mat-icon style="font-size: 44px;cursor: pointer;width: unset;height: unset;">save</mat-icon>
        <ng-container *ngIf="showText">
            <span multilang style="color: green;">Gespeichert !</span>
        </ng-container>
    </button>
</ng-container>

<ng-template #imagescount>
    <span multilang>{{currentImagePosition + 1}} / {{images?.length}}</span>
</ng-template>
<ng-template #videoscopunt>
    <span multilang>{{currentImagePosition + 1}} / {{videos?.length}}</span>
</ng-template>

<ng-template #minivideos>
    <div style="display: flex;overflow: auto;scrollbar-color: red;">
        <div class="miniimg clicable" style="height: 100px;width: 100px;min-width: 100px;margin: 0 0.4rem;"
            (click)="setCurrent($event, k)" *ngFor="let video of videos;index as k" ng-focus
            [appAutoFocus]="k === currentMiniImagePosition"
            [style.opacity]="k === currentMiniImagePosition ? '1' : '.6'">
            <video width="100%" style="border: 1px solid #fff;">
                <source [src]="video + '#t=0.001'">
                Your browser does not support HTML video.
            </video>
        </div>
    </div>
</ng-template>

<ng-template #miniimages>
    <div style="display: flex;overflow: auto;scrollbar-color: red;">
        <div class="miniimg clicable" style="height: 100px;width: 100px;min-width: 100px;margin: 0 0.4rem;"
            (click)="setCurrent($event, k)" *ngFor="let img of images;index as k" ng-focus
            [appAutoFocus]="k === currentMiniImagePosition"
            [style.opacity]="k === currentMiniImagePosition ? '1' : '.6'" tabindex="-1">
            <img *ngIf="img?.length > 0" [src]="img | cacheResource" loading="lazy" style="height: auto;width: 100%;"
                (error)="handelError(k)">
        </div>
    </div>
</ng-template>

<ng-template #bigvideos>
    <div class="imageslidercontent" (scroll)="scrolling()" #imageslidercontent>
        <div class="img" *ngFor="let video of videos;index as k"
            [class]="desktopTemplate !== 'xs' ? 'wideimagesliderimagecontent' : 'imagesliderimagecontent'">
            <video width="100%" height="100%" controls *ngIf="k === currentImagePosition">
                <source [src]="video + '#t=0.001'" preload="metadata">
                Your browser does not support HTML video.
            </video>
        </div>
    </div>
</ng-template>

<ng-template #bigimages>
    <div class="imageslidercontent" (scroll)="scrolling()" #imageslidercontent>
        <div class="img" *ngFor="let img of images;index as k"
            [class]="desktopTemplate !== 'xs' ? 'wideimagesliderimagecontent' : 'imagesliderimagecontent'">
            <ng-container *ngIf="k <= currentImagePosition + 1 && k >= currentImagePosition - 1">
                <img class="imgsrc" loading="lazy" (error)="handelError(k)" *ngIf="img?.length > 0"
                    [src]="img | cacheResource" alt="">
            </ng-container>
        </div>
    </div>
</ng-template>